export const REGION = 'us-west-2';
export const USER_POOL_ID = 'us-west-2_16ROpZsiB';
export const APP_CLIENT_ID = 'nhcv17f6c0cfrvd86ihamcka5';
export const IDENTITY_POOL_ID = 'us-west-2:cc46a234-6bb9-4470-905d-947951e9e21e';
export const COGNITO_DOMAIN = 'ee-portal-auth-beta.auth.us-west-2.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'beta';
export const APPEAL_ENABLED = 'true';